import { Content, ContentType } from "./content";

export class ImageContent extends Content {
    url!: string;

    constructor(url: string = "") {
        super();
        this.url = url;
    }

    getType(): ContentType {
        return ContentType.IMAGE;
    }

}